import { render } from "./ButtonAdd.vue?vue&type=template&id=bae3e944&scoped=true"
import script from "./ButtonAdd.vue?vue&type=script&lang=js"
export * from "./ButtonAdd.vue?vue&type=script&lang=js"

import "./ButtonAdd.vue?vue&type=style&index=0&id=bae3e944&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bae3e944"]])

export default __exports__